import { isBlankValue, type IdentifierRef } from './organisationDefaults';

export const OVERRIDE_SOLD_AS_LABEL = 'Override Sold As Variant';
export const OVERRIDE_BOUGHT_AS_LABEL = 'Override Bought As Variant';
export const RESET_SOLD_AS_LABEL = 'Reset to default Sold As variant';
export const RESET_BOUGHT_AS_LABEL = 'Reset to default Bought As variant';
export const RESET_BOTH_LABEL = 'Reset to default Bought and Sold Variants';
export const RESET_BOTH_FAILURE = 'The reset was not saved.';

export function rolesToReset(input: { soldOverride: boolean; boughtOverride: boolean }): Array<'sold_as' | 'bought_as'> {
  const roles: Array<'sold_as' | 'bought_as'> = [];
  if (input.soldOverride) roles.push('sold_as');
  if (input.boughtOverride) roles.push('bought_as');
  return roles;
}

export function canResetBothOverrides(input: { soldOverride: boolean; boughtOverride: boolean }): boolean {
  return rolesToReset(input).length > 0;
}
export const USE_THIS_LABEL = 'Use this';
export const CURRENT_LABEL = 'Current';
export const DONE_LABEL = 'Done';
export const SOLD_AS_HINT = 'Used in every table, report and export.';
export const BOUGHT_AS_HINT = 'Used on purchase orders and supplier documents.';
export { MISSING_CELL_FILL, MISSING_CELL_OUTLINE } from './organisationDefaults';

export interface SoldAsOption {
  columnKey: string;
  identifierType: string;
  value: string;
  columnLabel: string;
  current: boolean;
}

export function soldAsOptions(input: {
  columns: readonly { key: string; typeName: string }[];
  valuesByColumn: Record<string, string | null | undefined>;
  effectiveColumnKey: string | null;
  effectiveMissing: boolean;
}): SoldAsOption[] {
  return input.columns
    .filter((column) => !isBlankValue(input.valuesByColumn[column.key]))
    .map((column) => ({
      columnKey: column.key,
      identifierType: column.key.includes(':') ? column.key.slice(0, column.key.indexOf(':')) : column.key,
      value: (input.valuesByColumn[column.key] ?? '').trim(),
      columnLabel: column.typeName,
      current: !input.effectiveMissing && column.key === input.effectiveColumnKey,
    }));
}

export function canOverrideSoldAs(options: readonly SoldAsOption[]): boolean {
  return options.length > 1 || (options.length === 1 && !options[0].current);
}

export const boughtAsOptions = soldAsOptions;
export const canOverrideBoughtAs = canOverrideSoldAs;

export function selectBoughtAs(input: {
  option: SoldAsOption;
  defaultColumn: IdentifierRef | null;
}): { override: IdentifierRef | null; action: 'override' | 'reset' } {
  return selectSoldAs(input);
}

export function selectSoldAs(input: {
  option: SoldAsOption;
  defaultColumn: IdentifierRef | null;
}): { override: IdentifierRef | null; action: 'override' | 'reset' } {
  if (input.defaultColumn && input.option.columnKey === input.defaultColumn.columnKey) {
    return { override: null, action: 'reset' };
  }
  return {
    override: { columnKey: input.option.columnKey, identifierType: input.option.identifierType },
    action: 'override',
  };
}
